<template>
  <div class="content">
    <h1 class="content__title">Lista de Usuarios</h1>
    <span class="content__details">Listado de usuarios del administrador de contenidos y tambien de los clientes.</span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Lista de usuarios</h2>
          <div class="main__results">
            <div class="result" v-if="users === 'loading'">
              <div class="result__data">
                <img class="result__loading" src="/static/img/waiting.gif" alt="Cargando información">
              </div>
            </div>
            <div class="result" v-else-if="!users">
              <div class="result__data">
                <h2 class="result__title">No se encontraron resultados</h2>
              </div>
            </div>
            <div class="result" v-else v-for="(user, index) in users" :key="index">
              <div class="result__data">
                <h2 class="result__title" v-text="user.first_name + ' ' + user.last_name"></h2>
                <p class="result__detail" v-text="user.email"></p>
              </div>
              <div class="result__options">
                <router-link class="btn btn__default btn--small" :to="{name: 'userEdit', params: {id: user.id}}" > Editar</router-link>
                <button class="btn btn__caution btn--small" @click="deleteUser(user.id)">Borrar</button>
              </div>
            </div>

          </div>
          <pagination v-if="pagination.pages !== null" :config="pagination"></pagination>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">OPCIONES</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'userNew'}">Nuevo Usuario</router-link>
      </aside>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/api/request'
import pagination from '@/components/layout/pagination'
import confirmation from '@/components/layout/confirmation'
export default {
  mixins: [httpService],
  components: {
    pagination,
    confirmation
  },
  data: function () {
    return {
      confirm: false,
      users: 'loading',
      pagination: {
        maxButtons: 8,
        results: null,
        pages: null
      },
      maxResults: 12,
      page: 1,
      id: null
    }
  },
  created: function () {
    this.page = this.$route.params.page
    this.getUsers()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    '$route.path': function () {
      this.page = this.$route.params.page
      this.getUsers()
    }
  },
  methods: {
    deleteUser: function (id) {
      this.confirm = true
      this.id = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        module: 'users'
      }
      this.delete(this.id, httpRequest)
        .then(
          () => {
            this.getUsers()
            this.$store.commit('notificate', {
              title: 'USUARIO BORRADO',
              text: 'El usuario ha sido borrado correctamente.',
              type: 'success'
            })
          }
        )
    },
    getUsers: function () {
      let httpRequest = {
        module: 'users',
        params: '?fields=first_name,last_name,id,email&limit=' + this.maxResults + '&page=' + this.page + '&embed=pagination'
      }
      this.get(httpRequest)
        .then(
          users => {
            this.users = users.data
            this.pagination.pages = users.pagination.pages
            this.pagination.currentPage = users.pagination.current_page
            this.pagination.results = users.pagination.results
          }
        )
        .catch(
          () => {
            this.users = null
            this.pagination.pages = null
            this.pagination.currentPage = null
            this.pagination.results = null
            if (this.page > 1) {
              this.$router.push({name: 'userList', params: {page: this.page - 1}})
            }
          }
        )
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../assets/sass/objects/_btns"
</style>



// WEBPACK FOOTER //
// src/components/users/list.vue